// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleDropdown_wrapper__O2_Ko","cardDivider":"ArticleDropdown_cardDivider__lBm3y","cardDivide":"ArticleDropdown_cardDivide__cllCC"};